import $ from 'jquery'

const getFormData = ($form) => {
  const unIndexedArr = $form.serializeArray()
  const indexedArr = {}

  $.map(unIndexedArr, function (n) {
    indexedArr[n['name']] = n['value']
  })

  return indexedArr
}

export default getFormData
